import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardSelectedPatient,
    selectMedicationEntries
} from "../../redux/ProfessionalDashboard"
import notNull from "../../util/notNull"
import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import SmallestHeadingComponent from "../SmallestHeadingComponent"
import MedicationListAdd from "./component/MedicationListAdd"
import {
    DeleteMedicationEntrySpecification,
    GetPatientMedicationInformationSpecification, GetPatientsOfProfessionalResponsePayload
} from "pokal_api"
import { dispatchThunk } from "../../redux/thunk/thunkify"
import {
    medicationOnboardingIsRunning,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import { useEffect, useState } from "react"
import { ArrayElement } from "../../types/ArrayElement"
import mockPatient from "../../onboarding/mock/mockPatient"

function MedicationList() {

    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const onboardingStep = useAppSelector(selectOnboardingStep)

    const [selectedPatient, setSelectedPatient] = useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(null)
    const fetchedSelectedPatient = useAppSelector(selectDashboardSelectedPatient)

    useEffect(() => {
        if(medicationOnboardingIsRunning(onboardingIsRunning, onboardingStep)) {
            setSelectedPatient(mockPatient()[0])
        } else setSelectedPatient(fetchedSelectedPatient)
    }, [onboardingStep, onboardingIsRunning, fetchedSelectedPatient])

    const medicationInformation = useAppSelector(selectMedicationEntries)
    const dispatch = useAppDispatch()

    function onRemove(id: string) {
        const success = window.confirm(
            "Bitte bestätigen Sie, dass Sie das Medikament entfernen möchten."
        )
        if (success && notNull(selectedPatient)) {
            DeleteMedicationEntrySpecification.request({
                medication: id
            }).then(() =>
                dispatchThunk(
                    dispatch,
                    GetPatientMedicationInformationSpecification,
                    {
                        patient: selectedPatient.id
                    }
                )
            )
        }
    }

    return (
        <Card width={"100%"}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>
                    Medikation
                </SmallHeadingComponent>
                {selectedPatient === null && (
                    <div className={"italic"}>
                        Bitte wählen Sie eine Patient:in aus um Details sehen zu
                        können.
                    </div>
                )}
                {notNull(selectedPatient) && notNull(medicationInformation) && (
                    <div>
                        <SmallestHeadingComponent>
                            Antidepressiva
                        </SmallestHeadingComponent>
                        <ul className={"ml-6"}>
                            {medicationInformation.medication.map((med) => (
                                <div
                                    className={"list-disc flex space-x-2"}
                                    key={med.id}>
                                    <span>{med.name}</span>
                                    <span
                                        className={
                                            "text-rose-600 hover:underline cursor-pointer"
                                        }
                                        onClick={() => onRemove(med.id)}>
                                        (Medikament entfernen)
                                    </span>
                                </div>
                            ))}
                        </ul>
                        {medicationInformation.medication.length === 0 && (
                            <div className={"italic"}>
                                Keine Antidepressiva bekannt.
                            </div>
                        )}
                    </div>
                )}
                {notNull(medicationInformation) && notNull(selectedPatient) && (
                    <div>
                        <SmallestHeadingComponent>
                            Komedikation
                        </SmallestHeadingComponent>
                        <ul className={"ml-6"}>
                            {medicationInformation.coMedication.map((med) => (
                                <li
                                    className={"list-disc flex space-x-2"}
                                    key={med.id}>
                                    <span>{med.name}</span>
                                    <span
                                        className={
                                            "text-rose-600 hover:underline cursor-pointer"
                                        }
                                        onClick={() => onRemove(med.id)}>
                                        (Medikament entfernen)
                                    </span>
                                </li>
                            ))}
                        </ul>
                        {medicationInformation.coMedication.length === 0 && (
                            <div className={"italic"}>
                                Keine Komedikation bekannt.
                            </div>
                        )}
                    </div>
                )}
                {notNull(selectedPatient) && (
                    <MedicationListAdd patient={selectedPatient.id} />
                )}
            </div>
        </Card>
    )
}

export default MedicationList
